module.exports = __webpack_public_path__ + "img/wheat_nss1490.a94d6631.jpg";